import { useTranslation } from "react-i18next";

export default function SafetyNote() {
  const { t } = useTranslation();

  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto max-w-4xl px-4 md:px-6 pb-6">
        <div className="flex items-start gap-4 rounded-2xl border border-accent-200 bg-accent-50 px-5 py-5">
          <span className="w-10 h-10 flex items-center justify-center text-accent-600 shrink-0">
            <i className="ri-shield-check-line text-2xl"></i>
          </span>
          <div>
            <h4 className="font-heading text-base md:text-lg font-bold text-accent-900">
              {t("safety.title")}
            </h4>
            <p className="mt-1 text-sm text-foreground-700 leading-relaxed">
              {t("safety.body")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}